export const INVITE_TRAVELER_SCENARIO = 'invite_traveler_scenario';
// Invite traveler scenarios
export const INVITE_TRAVELER_SCENARIOS = {
  SIGNED_IN: 'signedIn',
  SOCIAL_SIGN_UP: 'socialSignUp',
  EMAIL_SIGN_UP: 'emailSignUp',
};
